import React, { lazy } from 'react';

import { IContentTemplateData } from '../types';

import DeferredBlock from '../primitives/DeferredBlock';

const AppStoresBanner = lazy(() => import('../../AppStoresBanner/AppStoresBanner'));
const ArticlesSearch = lazy(() => import('../../ArticlesSearch/ArticlesSearch'));

interface IStoreAndSearchProps {
    data: IContentTemplateData;
}

const StoreAndSearch: React.FC<IStoreAndSearchProps> = ({ data }) => (
    <>
        {data.hasDownloadApp && (
            <DeferredBlock
                region="download-app"
                className="content-block content-block--download-app"
                placeholderHeight={240}
            >
                <div className="content-block content-block--download-app"><AppStoresBanner /></div>
            </DeferredBlock>
        )}

        {data.hasSearchDesk && (
            <DeferredBlock
                region="search-desk"
                className="content-block content-block--search-desk"
                placeholderHeight={48}
            >
                <div className="content-block content-block--search-desk"><ArticlesSearch /></div>
            </DeferredBlock>
        )}
    </>
);

export default StoreAndSearch;
